import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=fe68c376&"
import script from "./Clients.js?vue&type=script&lang=js&"
export * from "./Clients.js?vue&type=script&lang=js&"
import style0 from "./Clients.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports